import { render, staticRenderFns } from "./resumo-regularidade-fiscal.vue?vue&type=template&id=ba6dae28&scoped=true"
import script from "./resumo-regularidade-fiscal.vue?vue&type=script&lang=js"
export * from "./resumo-regularidade-fiscal.vue?vue&type=script&lang=js"
import style0 from "./resumo-regularidade-fiscal.vue?vue&type=style&index=0&id=ba6dae28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6dae28",
  null
  
)

export default component.exports